import _ from 'lodash';
import { QueryString } from '~/utils';
import { get, post, del, patch } from './agent';

const opportunityProjects =
  (opportunityProjectsUrl) =>
  (projectId = '') => {
    const url = _([opportunityProjectsUrl, projectId]).compact().join('/');

    return {
      get: (query = {}) => get(url.concat(new QueryString(query).toString(true))),
      selectOptions: (query = {}) => get(url.concat('/select-options').concat(new QueryString(query).toString(true))),
      stats: (query = {}) => get(url.concat('/stats').concat(new QueryString(query).toString(true))),
      update: (body) => patch(url, body),
      add: (body) => post(url, body),
      remove: () => del(url),
    };
  };

export default opportunityProjects;
